import { ChartDataset } from 'chart.js';

const chart: null | HTMLCanvasElement = document.getElementById(
    'outlineChart',
) as HTMLCanvasElement;
const datasets: null | ChartDataset[] = JSON.parse(
    document.getElementById('outlineChartData')?.textContent || '[]',
);

if (chart && datasets) {
    import('../OutlinesChart').then(function (OutlineChart) {
        OutlineChart.default(chart, datasets);
    });
}
